module.exports = __webpack_public_path__ + "media/images/fb-icon-white-54bcd21e69680cd579dbee62851b9492.png";